(() => {
  if (window.rbOfferProgressCopyReady) return;

  window.rbOfferProgressCopyReady = true;
  const resetTimers = new WeakMap();

  const legacyCopy = (value) => {
    const textArea = document.createElement('textarea');
    textArea.value = value;
    textArea.readOnly = true;
    textArea.style.position = 'fixed';
    textArea.style.inset = '-9999px auto auto -9999px';
    document.body.appendChild(textArea);
    textArea.select();
    const copied = document.execCommand('copy');
    textArea.remove();
    if (!copied) throw new Error('Copy failed');
  };

  const copyValue = async (value) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return;
    }
    legacyCopy(value);
  };

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement)) return;
      if (!details.open || !details.closest('.rb-offer-progress--drawer')) return;

      window.requestAnimationFrame(() => {
        const scroller = details.closest('cart-drawer-items');
        const tiers = details.querySelector('.rb-offer-progress__tiers');
        const rows = scroller?.querySelectorAll('.cart-item');
        const lastRow = rows?.[rows.length - 1];
        if (!scroller || !tiers || !lastRow) return;

        const scrollerRect = scroller.getBoundingClientRect();
        const tiersRect = tiers.getBoundingClientRect();
        const rowRect = lastRow.getBoundingClientRect();
        const visiblePixels = (rect) =>
          Math.max(0, Math.min(rect.bottom, scrollerRect.bottom) - Math.max(rect.top, scrollerRect.top));
        const tierRevealNeeded = Math.max(0, Math.min(80, tiersRect.height) - visiblePixels(tiersRect));
        const productScrollAllowance = Math.max(0, visiblePixels(rowRect) - 120);
        const scrollAmount = Math.min(tierRevealNeeded, productScrollAllowance);

        if (scrollAmount <= 0) return;
        scroller.scrollBy({
          top: scrollAmount,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      });
    },
    true
  );

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('[data-rb-copy-code]');
    if (!button) return;

    const component = button.closest('[data-rb-offer-progress]');
    const feedback = component?.querySelector('[data-rb-copy-feedback]');
    const code = button.dataset.rbCopyCode;
    if (!code) return;

    const existingTimer = resetTimers.get(button);
    if (existingTimer) window.clearTimeout(existingTimer);

    button.disabled = true;

    try {
      await copyValue(code);
      button.textContent = button.dataset.rbCopiedLabel;
      if (feedback) feedback.textContent = button.dataset.rbCopiedFeedback;
    } catch (error) {
      button.textContent = button.dataset.rbCopyFailedLabel;
      if (feedback) feedback.textContent = button.dataset.rbCopyFailedFeedback;
    } finally {
      button.disabled = false;
      const timer = window.setTimeout(() => {
        button.textContent = button.dataset.rbDefaultLabel;
        resetTimers.delete(button);
      }, 2400);
      resetTimers.set(button, timer);
    }
  });
})();
